import styled from "styled-components";
import media from "styled-media-query";

import { firebaseMedia } from "utils";

export type LogoProps = {
  color?: "white" | "black";
};

export const Logo = styled.img.attrs<LogoProps>(({ color = "black" }) => ({
  src: firebaseMedia(
    {
      black: "logos/porto-seguro.svg",
      white: "logos/porto-seguro-white.svg",
    }[color]
  ),
}))<LogoProps>`
  height: 4vh;

  ${media.greaterThan("large")`
    position: absolute;
    top: 30px;
    left: 20px;
  `}

  ${media.greaterThan("huge")`
    top: 50px;
    left: 40px;
  `}

  ${media.lessThan("large")`
    margin-left: 20px;
    margin-bottom: 20px;
  `}
`;
